import { deleteIva, getIvaLista } from "../../services/IVAServices";
import { IvaContext } from "./IvaContext"

export const IvaState = ({ children }) => {
    const getIvaListaData = async () => {
        let res = await getIvaLista()
        return res
    }

    const deleteIvaData = async (body) => {
        const res = await deleteIva(body)
        if (res) getIvaListaData()
        return res
    }

    return <IvaContext.Provider value={{
        deleteIvaData,
        getIvaListaData
    }} >
        {children}
    </IvaContext.Provider>
}